import { Link, Typography } from '@mui/material';

const RecaptchaLinks = () => {
  return (
    <Typography variant={'body2'} sx={{ fontSize: 9 }} color={'textSecondary'}>
      {'This site is protected by reCAPTCHA and the Google '}
      <Link
        href="https://policies.google.com/privacy"
        target="_blank"
        sx={{ textDecoration: 'underline', color: 'inherit' }}
        rel={'noopener nofollow'}
      >
        {'Privacy Policy'}
      </Link>
      {' and '}
      <Link
        href="https://policies.google.com/terms"
        target="_blank"
        sx={{ textDecoration: 'underline', color: 'inherit' }}
        rel={'noopener nofollow'}
      >
        {'Terms of Service'}
      </Link>
      {' apply.'}
    </Typography>
  );
};
export default RecaptchaLinks;
